import { useState, useEffect } from 'react';
import UserAgreementService from '../components/user/common/services/UserAgreementService';

export const useAgreementCheck = (trigger, userType, autoCheck = true) => {
  const [pendingAgreements, setPendingAgreements] = useState([]);
  const [requiresAcceptance, setRequiresAcceptance] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const checkPendingAgreements = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await UserAgreementService.getRequiredDocuments(trigger, userType);
      
      if (response.success && response.data?.length > 0) {
        setPendingAgreements(response.data);
        setRequiresAcceptance(true);
      } else {
        setPendingAgreements([]);
        setRequiresAcceptance(false);
      }
    } catch (err) {
      setError(err.message);
      console.error('Error checking pending agreements:', err);
    } finally {
      setLoading(false);
    }
  };

  const markAgreementsAccepted = () => {
    setPendingAgreements([]);
    setRequiresAcceptance(false);
  };

  useEffect(() => {
    if (autoCheck && trigger) {
      checkPendingAgreements();
    }
  }, [trigger, userType, autoCheck]);

  return {
    pendingAgreements,
    requiresAcceptance,
    loading,
    error,
    checkPendingAgreements,
    markAgreementsAccepted
  };
};